// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const FeatureTypeDefinition = {
  StudyArea: "study_area",
  BuildingFloorLevel: "building_floor_level",
  BuildingFloodRisk: "building_flood_risk",
  BuildingAdvancedFloodRisk: "building_advanced_flood_risk",
  RoadAccessibility: "road_accessibility",
  DrainagePattern: "drainage_pattern",
  Basin: "basin",
  DhydroFreeboard: "dhydro_freeboard",
  GwswManagementActivities: "gwsw_management_activities",
  SchematisationCheck: "schematisation_check",
  NwbRoads: "nwb_roads",
  HccSchematisationExport: "hcc_schematisation_export",
} as const;
export type FeatureTypeDefinition =
  (typeof FeatureTypeDefinition)[keyof typeof FeatureTypeDefinition];

export function instanceOfFeatureTypeDefinition(value: any): boolean {
  for (const key in FeatureTypeDefinition) {
    if (Object.prototype.hasOwnProperty.call(FeatureTypeDefinition, key)) {
      if (FeatureTypeDefinition[key as keyof typeof FeatureTypeDefinition] === value) {
        return true;
      }
    }
  }
  return false;
}

export function FeatureTypeDefinitionFromJSON(json: any): FeatureTypeDefinition {
  return FeatureTypeDefinitionFromJSONTyped(json, false);
}

export function FeatureTypeDefinitionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FeatureTypeDefinition {
  return json as FeatureTypeDefinition;
}

export function FeatureTypeDefinitionToJSON(value?: FeatureTypeDefinition | null): any {
  return value as any;
}

export function FeatureTypeDefinitionToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): FeatureTypeDefinition {
  return value as FeatureTypeDefinition;
}
